import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6cf41db0&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=6cf41db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf41db0",
  null
  
)

export default component.exports